import React, {useEffect} from "react";
import { Footer, Header } from "../Components";
import FooterTopBar from "../Components/FooterTopBar";

export const RefundPolicy = () => {
  document.title = "Refund/Cancellation Policy - Famra Cure";
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-left mb-8 text-sky-800">
            Refund/Cancellation Policy
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">1. Cancellations & Rescheduling</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-3">
                <li>
                  <strong>Cancellations:</strong> Prepaid appointments are non-refundable or cannot be cancelled in any case.
                </li>
                <li>
                  <strong>Provider Changes:</strong> If a doctor postpones the video consultation day/time due to his/her non-availability or others; we will notify you to reschedule or re-book via the platform as per availability of the doctor.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">2. Refund Policy</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-3">
                <li>
                  <strong>Eligibility:</strong> Refunds are only issued for appointments completely/permanently cancelled by the doctor.
                </li>
                <li>
                  <strong>Timeline:</strong> Refunds are typically processed within 14 working days. Famra Cure is not responsible for delays caused by your bank. The refund amount will be transferred through same medium of the user by which it was submitted during appointment booking.
                </li>
                <li>
                  Please note that we shall not be responsible for any delays in credit to the Cardholder's credit card account/account holder's bank account due to any reasons cited by the Payment Gateway or Cardholder's issuing bank.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">3. Refund Exclusions</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Refunds will not be issued in the following circumstances:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-3">
                <li>
                  <strong>Post-Consultation Dissatisfaction:</strong> If the patient is unhappy with the doctor's advice or consultation after it has taken place.
                </li>
                <li>
                  <strong>Patient No-Show:</strong> If the patient is unavailable or fails to join at the scheduled appointment time.
                </li>
                <li>
                  <strong>Inappropriate Conduct:</strong> If the patient is rude or behaves inappropriately toward the healthcare provider.
                </li>
                <li>
                  <strong>Verification Issues:</strong> If the patient fails to provide valid payment evidence or necessary account details for verification.
                </li>
                <li>
                  <strong>Completed Services:</strong> Payments made for bills or services already rendered are non-refundable.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">4. Liability & Legal</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-3">
                <li>
                  <strong>No Warranty:</strong> The service is provided "as is" without express or implied warranties.
                </li>
                <li>
                  <strong>Variations:</strong> Famra Cure reserves the right to amend these Terms and Conditions at its discretion. Continued use of the service constitutes acceptance of the version published on this website. Furthermore, Famra Cure retains the right to reject any payment instruction without assigning any reason or justification.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Contact Us</h2>
              <p className="text-gray-700 leading-relaxed">
                For refund requests or questions, please contact our support team at <a href="mailto:support@famracure.com" className="font-bold text-sky-800 hover:text-sky-600 transition-colors">support@famracure.com</a> or through your patient portal.
              </p>
            </section>

            <p className="text-sm text-gray-600 mt-8 pt-4 border-t">
              Last Updated: June 2026
            </p>
          </div>
        </div>
      </div>
      <FooterTopBar />
      <Footer />
    </>
  );
};

export default RefundPolicy;
